import { FC, Suspense } from 'react';
import UserPostSection from './post';
import UserCampaignSection from './campaign';
import UserDescriptionSection from './description';
import { UserBodySkeleton } from '~/skeleton/user';
import UserRelatedSection from './related-user';

export const UserBody: FC = () => {
  return (
    <>
      <UserDescriptionSection />
      <Suspense fallback={<UserBodySkeleton />}>
        <UserPostSection />
        <UserRelatedSection />
        <UserCampaignSection />
      </Suspense>
    </>
  );
};
